<button class="icon icon-close icon-close" (click)="cancelSupervisorAction.emit()" i18n></button>
<button *ngIf="step !== 1" class="icon icon-arrow-back icon-back" (click)="goBack()" i18n></button>

<div #gamesContainer class="overlay">
    <div class="overlay-inner">
        <div *ngIf="step === 1" class="title">
            <span i18n>Scan card to continue</span>
        </div>

        <div *ngIf="step === 2" class="form-step">
            <div class="title">
                <span i18n class="user-id">User ID </span>
                <span class="id-number">{{ userId }}</span>
            </div>

            <p class="description" i18n>Edit/add user credentials to continue.</p>

            <form (ngSubmit)="submitForm()" #form="ngForm">
                <input
                    #nameInput
                    type="text"
                    name="name"
                    id="name"
                    placeholder="Name"
                    i18n-placeholder
                    [(ngModel)]="user.name"
                    required
                    (focus)="onInputFocus()"
                />

                <div #tableGroupDropdown class="custom-dropdown" [class.open]="tableGroupDropdownOpen">
                    <button type="button" class="dropdown-toggle" (click)="toggleTableGroupDropdown()">
                        <span [class.placeholder]="user.tableGroups.length === 0">
                            {{ tableGroupDisplay }}
                        </span>
                        <span class="dropdown-icon">{{ tableGroupDropdownOpen ? '▲' : '▼' }}</span>
                    </button>

                    <div class="dropdown-menu" *ngIf="tableGroupDropdownOpen">
                        <div
                            class="dropdown-item"
                            *ngFor="let group of tableGroups; trackBy: trackByGroup"
                            (click)="toggleTableGroup(group)"
                            [class.selected]="tableGroupSelection[group]"
                        >
                            <span class="checkbox"></span>
                            <span>{{ group }}</span>
                        </div>
                    </div>
                </div>

                <div #roleDropdown class="custom-dropdown" [class.open]="roleDropdownOpen">
                    <button type="button" class="dropdown-toggle" (click)="toggleRoleDropdown()">
                        <span [class.placeholder]="!user.accessLevel">
                            {{ user.accessLevel || 'ROLE' }}
                        </span>
                        <span class="dropdown-icon">{{ roleDropdownOpen ? '▲' : '▼' }}</span>
                    </button>
                    <div class="dropdown-menu" *ngIf="roleDropdownOpen">
                        <div
                            class="dropdown-item"
                            *ngFor="let accessLevel of roles; trackBy: trackByRole"
                            (click)="selectRole(accessLevel)"
                            [class.selected]="user.accessLevel === accessLevel"
                        >
                            <span>{{ accessLevel }}</span>
                        </div>
                    </div>
                </div>

                <button class="submit button button-medium button-accent" type="submit" [disabled]="!isFormValid" i18n>Continue</button>
            </form>

            <div #keyboardContainer class="keyboard-container" [class.hidden]="!keyboard"></div>
        </div>

        <div *ngIf="step === 3" class="confirm-step">
            <div class="title">
                <span i18n class="user-id">User ID </span>
                <span class="id-number">{{ userId }}</span>
            </div>

            <p class="description" i18n>Edit/add user credentials to continue.</p>

            <button class="edit-user button button-medium button-neutral" (click)="editUser()" i18n>Edit user</button>

            <button class="confirm button button-medium button-accent" (click)="cancelSupervisorAction.emit()" i18n>Continue</button>
        </div>
    </div>
</div>
